import { defineMessages } from '@atlassian/jira-intl';

// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */
export const messages = defineMessages({
	errorFlagTitle: {
		id: 'issue.view.assign-invited-user-service.error.flag.title-non-final',
		defaultMessage: 'We couldn’t assign this issue',
		description: 'Flag title: Is shown to users if the assign invited user fails',
	},
	errorFlagDescription: {
		id: 'issue.view.assign-invited-user-service.error.flag.description-non-final',
		defaultMessage:
			'Try adding the assignee again. If this problem persists, contact your site administrator.',
		description: 'Flag description: Is shown to users if the assign invited user fails',
	},
});
